import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MsisdnForwardingAdapter } from '@data/data/adapters/msisdn-forwarding/msisdn-forwarding.adapter';
import { MsisdnForwardingHeader, MsisdnForwardingRespDto } from '@data/data/models/msisdn-forwarding.dto';
import { RenewalPackageRespDto } from '@data/data/models/renewal-package.dto';
import { MsisdnForwardingEntity } from '@data/domain/msisdn-forwarding.entity';
import { RenewalPackageRepository } from '@data/repositories/renewal-package.repository';
import { environment } from '@environments/environment';
import { HttpService } from '@shared/services.http';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
providedIn: 'root'
})

export class RenewalPackageImplementation extends RenewalPackageRepository {
    http = inject(HttpService);

    msisdnForwardingAdapter = new MsisdnForwardingAdapter();


    msisdnForwarding(header: MsisdnForwardingHeader): Observable<MsisdnForwardingEntity> {
        return this.http.get<MsisdnForwardingRespDto, null>(`${environment.serviceApi}v1/renewal-contract/get-msisdn`, null, [{ key: 'X-msisdn', value: header['X-msisdn'] }], true).pipe(
            map((dto: MsisdnForwardingRespDto) => {
                return this.msisdnForwardingAdapter.mapFrom(dto);
            }),
            catchError((error: HttpErrorResponse) => {
                return throwError(() => error.error);
            })
        );
    }

    getRenewalPackage(): Observable<RenewalPackageRespDto> {
        return this.http.get<RenewalPackageRespDto, null>(`${environment.serviceApi}v1/renewal-contract/filteroffers`, null, [], true).pipe(
            catchError((error: HttpErrorResponse) => {
                return throwError(() => error.error);
            })
        );
    }
}